import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IOpsDepartment } from 'types/opsDepartments.interface'
import { IDeptOpsProfilesSlice } from 'types/deptOpsConfig.interface'
import { opsDepartments } from 'pages/Operations/Shared/opsDepartments'

const initialState: IDeptOpsProfilesSlice = {
  profiles: opsDepartments(),
}

const deptOpsProfilesSlice = createSlice({
  name: 'deptOpsProfiles',
  initialState,
  reducers: {
    setKpiTemplate: (
      state,
      action: PayloadAction<{ key: string; kpiTemplate: IOpsDepartment['kpiTemplate'] }>,
    ) => {
      state.profiles = state.profiles.map((p) =>
        p.key === action.payload.key ? { ...p, kpiTemplate: action.payload.kpiTemplate } : p,
      )
    },
    setSortOrder: (state, action: PayloadAction<{ key: string; sortOrder: number }>) => {
      state.profiles = state.profiles.map((p) =>
        p.key === action.payload.key ? { ...p, sortOrder: action.payload.sortOrder } : p,
      )
    },
  },
})

export const { setKpiTemplate, setSortOrder } = deptOpsProfilesSlice.actions
export default deptOpsProfilesSlice.reducer
